import {Visibility, VisibilityOff} from "@mui/icons-material";
import {
  IconButton,
  InputAdornment,
  TextField,
  TextFieldProps,
  TextFieldVariants,
} from "@mui/material";
import {useState} from "react";

type Props = {
  name: string;
  variant?: TextFieldVariants;
} & Omit<TextFieldProps, "variant">;

export default function Password(props: Props) {
  const [showPassword, setShowPassword] = useState<boolean>(false);
  const [value, setValue] = useState<string>((props.value as string) ?? "");
  const handleClickShowPassword = () => setShowPassword(!showPassword);
  const handleMouseDownPassword = () => setShowPassword(!showPassword);

  const handleChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>,
  ) => {
    setValue(e.target.value);
    if (props.onChange) {
      props.onChange(e);
    }
  };
  return (
    <TextField
      {...props}
      onChange={handleChange}
      type={showPassword ? "text" : "password"}
      value={value}
      slotProps={{
        input: {
          endAdornment: (
            <InputAdornment position="end">
              <IconButton
                aria-label="toggle password visibility"
                size="small"
                onClick={handleClickShowPassword}
                onMouseDown={handleMouseDownPassword}>
                {showPassword ? (
                  <VisibilityOff fontSize="small" />
                ) : (
                  <Visibility fontSize="small" />
                )}
              </IconButton>
            </InputAdornment>
          ),
        },
      }}
    />
  );
}
